import { traverse } from "@babel/core";
import moment from "moment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { BooleanType, ClassType, DateType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../structure";
import { DataModelBuilderViewModel, DataModelClass, Method, Property } from "./dataModelBuilder-viewModel";

export class DataModelToSourceCodeConverter{
    public getSourceCode(model:DataModelBuilderViewModel):string{
        let result = model.classes.map(x=>this.getClassSourceCode(x)).join('\r\n');
        return result;
    }
    private getClassSourceCode(cls:DataModelClass):string{
        let methods = cls.methods.map(x=>this.getCodeForMethod(x)).join('\r\n');
        let properties = cls.properties.map(x=>this.getCodeForProperty(x)).join('\r\n');
        let result = `
export class ${cls.name} extends BaseType{
    
${properties}

${methods}
}`;
        return result;
    }

    private getCodeForMethod(p:Method):String{
        function getCode(body:any):string{
            let result = '';
            try{
                result = body[0].Code;
            }catch(ex){
    
            }
            finally{
                if(stringIsNullOrEmpty(result)){
                    result = '';
                }
            }
            return result;
        }
        let pre = '';
        let resolver = new typeNameResolver();
        let returnType = resolver.getName(p.returnType);
        if(p.isAsync){
            pre='async ';
            returnType=`Promise<${returnType}>`;
        }
        return `\t${pre}${p.name}(${p.arguments.map(x=>`${x.name}:${resolver.getName(x.type)}`)}):${returnType}{
\t\t${getCode(p.body).trim()}
\t}`;
    }

    private getCodeForProperty(p:Property):string{
        function getPrePostCode(body:any,requireReturn:boolean):string{
            let result = '';
            try{
                result = body[0].Code;
            }catch(ex){
    
            }
            finally{
                if(stringIsNullOrEmpty(result)){
                    if(requireReturn)
                        result = 'return true;';
                    else
                        result = '';
                }
            }
            return result;
        }
        let resolver = new typeNameResolver();
        let typeName =resolver.getName(p.type);
        let propertyName = p.name;
        let preCode:string = getPrePostCode(p.preBody,true);
        let postCode : string = getPrePostCode(p.postBody,false);

        let result =`
\tpublic ${propertyName}:${typeName};
\tpublic pre_${propertyName}(oldValue:${typeName},newValue:${typeName}):boolean{
\t\t${preCode.trim()}    
\t}
\tpublic post_${propertyName}(oldValue:${typeName},newValue:${typeName}){
\t\t${postCode.trim()}    
\t}`
        return result;
    }
}


class typeNameResolver implements IPropertyTypeVisitor {
    
    getName(type:PropertyType):string{
        return type.Accept(this,null);
    }    

    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return 'DataLoader';
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        return 'void';
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return 'boolean';
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return 'number';
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return 'number';
    }
    visitStringType(arg0: StringType, parameter: any) {
        return 'string';
    }
    visitListType(arg0: ListType, parameter: any) {
        return `ObservableArray<${this.getName(arg0.OfType)}>`;
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return 'any';
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return arg0.ForClass.name;
    }
    visitDateType(arg0: DateType, parameter: any) {
        return "moment.Moment";
    }    
}
